import React, { useCallback, useState } from 'react';
import useTranslations from '../../hooks/useTranslations';
import FormBuilderAutomationCardView, {
  StaticFormBuilderAutomationCardView
} from '../view/FormBuilderAutomationCardView';

// STRUCTURE EXAMPLE:
// {
//   label: 'When a form is created',
//   rule: {
//     when: {
//       eventType: 'first_update'
//     },
//     action: {
//       actionType: 'fieldupdate',
//       additionalParameters: {
//         statusData: {
//           status: 'completed'
//         }
//       }
//     }
//   },
//   position: 1,
//   id: generateId()
// }

const FormBuilderAutomationCardEngine = ({
  automationData,
  update = () => {},
  onEdit = () => {},
  onDelete = () => {},
  staticCard
}) => {
  const t = useTranslations();
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isInDeleteSequence, setIsInDeleteSequence] = useState(false);

  const onToggleSwitch = useCallback(
    e => {
      const value = e.target.checked;
      const automationDataCpy = JSON.parse(JSON.stringify(automationData));
      automationDataCpy.disabled = !value;

      update(automationDataCpy, true);
    },
    [automationData]
  );

  const onStaticTriggerChange = useCallback(
    data => {
      const automationDataCpy = JSON.parse(JSON.stringify(automationData));
      automationDataCpy.rule.action.additionalParameters =
        data.additionalParameters;

      update(automationDataCpy);
    },
    [automationData]
  );

  const viewProps = {
    automationData,
    id: automationData.internalId,
    position: automationData.position,
    title: t(automationData.label) || '',
    update,
    trigger:
      automationData &&
      automationData.rule &&
      automationData.rule.when &&
      automationData.rule.when.eventType,
    onStaticTriggerChange,
    onToggleSwitch,
    onEdit,
    onDelete,
    isDeleteDialogOpen,
    setIsDeleteDialogOpen,
    setIsInDeleteSequence,
    isInDeleteSequence,
    isChecked: !automationData.disabled
  };

  return staticCard ? (
    <StaticFormBuilderAutomationCardView {...viewProps} />
  ) : (
    <FormBuilderAutomationCardView {...viewProps} />
  );
};

export default FormBuilderAutomationCardEngine;
